import React from 'react';
import { PageHeaderNew } from '@/components/ui/PageHeaderNew';
import { HelpSearchBar } from './components/HelpSearchBar';
import { HelpCategoryGrid } from './components/HelpCategoryGrid';
import { FAQAccordion } from './components/FAQAccordion';
import { SupportTicketCard } from './components/SupportTicketCard';

export function HelpCenterPage() {
  return (
    <div className="flex flex-col gap-6 animate-in fade-in duration-500 w-full flex-1 min-w-0">
      <PageHeaderNew 
        title="Trung tâm Trợ giúp"
        subtitle="Khám phá tài liệu hướng dẫn và liên hệ hỗ trợ kỹ thuật"
        backUrl="/dashboard"
      />

      {/* Main Grid Layout - 8/4 Split (2/3 and 1/3) */}
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 items-start">
        
        {/* Left Column (Span 8) */}
        <div className="xl:col-span-8 flex flex-col gap-8 min-w-0">
          <HelpSearchBar />
          
          <div>
            <h3 className="sm:text-sm text-xs font-semibold text-slate-800 mb-4 px-1">Tài liệu theo chủ đề</h3>
            <HelpCategoryGrid />
          </div>

          <div className="pb-8">
            <FAQAccordion />
          </div>
        </div>

        {/* Right Column (Span 4) */}
        <div className="xl:col-span-4 min-w-0">
          <SupportTicketCard />
        </div>
        
      </div>
    </div>
  );
}

export default HelpCenterPage;
